module.exports = __webpack_public_path__ + "img/category-blouses.2d166300.jpg";